import React from 'react';
import { ChevronDown, Moon, Palette, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export const ThemeToggle = ({ showLabel = false }) => {
  const { theme, setTheme, themes, activeTheme } = useTheme();

  return (
    <details className="relative">
      <summary
        className="inline-flex h-10 list-none cursor-pointer items-center justify-center gap-1.5 rounded-full border border-white/15 bg-black/20 px-2.5 text-white shadow-sm backdrop-blur-sm hover:border-white/30 sm:px-3"
        aria-label={`Fargetema: ${activeTheme?.label || ''}`}
        title={`Fargetema: ${activeTheme?.label || ''}`}
      >
        <span className="h-3 w-3 rounded-full border border-white/25" style={{ background: activeTheme?.color }} aria-hidden="true" />
        <Palette size={15} aria-hidden="true" />
        <span className={showLabel ? 'inline text-xs font-semibold' : 'hidden text-xs font-semibold sm:inline'}>{activeTheme?.label}</span>
        <ChevronDown size={13} aria-hidden="true" />
      </summary>
      <div className="absolute right-0 z-[70] mt-2 w-48 rounded-xl border border-white/10 bg-[#0f0a17] p-1.5 shadow-2xl" role="group" aria-label="Velg fargetema">
        {themes.map((option) => {
          const Icon = option.value === 'original' ? Moon : option.value === 'light' ? Sun : Palette;
          const active = theme === option.value;
          return (
          <button
            key={option.value}
            type="button"
            onClick={(event) => {
              setTheme(option.value);
              event.currentTarget.closest('details').open = false;
            }}
            aria-pressed={active}
            className={`flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-left text-sm font-semibold transition-colors ${active ? 'bg-white/10 text-white' : 'text-white/75 hover:bg-white/5 hover:text-white'}`}
            aria-label={`Bytt til ${option.label} tema`}
          >
            <span className="h-3.5 w-3.5 shrink-0 rounded-full border border-white/25" style={{ background: option.color }} aria-hidden="true" />
            <Icon size={15} aria-hidden="true" />
            <span className="flex-1">{option.label}</span>
            {active && <span className="text-[10px] uppercase tracking-wide text-white/50">Valgt</span>}
          </button>
          );
        })}
      </div>
    </details>
  );
};
